export const NOSTRO_LADDER_PROJECTION_BALANCE_TYPE_TRANSACTION = 'TRANSACTION';
export const NOSTRO_LADDER_PROJECTION_BALANCE_TYPE_PROJECTION = 'PROJECTION';

export class NostroLadderData {
    currency: string;
    account: string;
    runningBalance: number;
    runningProjected: number;
    openingBalance: number;
    openingExpectation: number;

    projectionDataByKey: Map<String, NostroLadderProjectionData> = new Map<String, NostroLadderProjectionData>();

    addProjectionData(projectionData: NostroLadderProjectionData) {
        this.projectionDataByKey.set(projectionData.key(), projectionData);
        this.runningProjected += projectionData.startBalance;
    }

    getProjectionData(clientGroup: string, product: string): NostroLadderProjectionData {
        return this.projectionDataByKey.get(clientGroup + '.' + product);
    }

    clone(): NostroLadderData {
        const copy: NostroLadderData = Object.assign(new NostroLadderData(), this);
        copy.projectionDataByKey = new Map<String, NostroLadderProjectionData>();
        this.projectionDataByKey.forEach((value: NostroLadderProjectionData, key: string) => {
            const subCopy: NostroLadderProjectionData = value.clone();
            copy.projectionDataByKey.set(subCopy.key(), subCopy);
        });
        return copy;
    }
}

export class NostroLadderProjectionData {
    balanceType: string;
    currency: string;
    account: string;
    clientGroup: string;
    product: string;
    startBalance: number;

    key() {
        return this.clientGroup + '.' + this.product;
    }

    clone(): NostroLadderProjectionData {
        return Object.assign(new NostroLadderProjectionData(), this);
    }
}

